// import { WgisService } from './wgis.service';
import { WGisServiceInterface } from './wgis.utils';

import Feature from 'ol/Feature';
// import Layer from 'ol/layer/Layer';
// import Point from 'ol/geom/Point';
// import WKT from 'ol/format/WKT';
import { WGisEngine } from './wgis.engine';
import {
  EngineType, FieldsInterface, MapEngineOptions, BaseEngine,
  WGisFeatureInfo, WGisFeatureInterface
} from './wgis.utils';

import TileGrid from 'ol/tilegrid/TileGrid';
import { Tile as TileLayer } from 'ol/layer';
import { XYZ } from 'ol/source';
import { Options as XyzOpts } from 'ol/source/XYZ';
import { TileCoord } from 'ol/tilecoord';
import Projection from 'ol/proj/Projection';
import { Extent } from 'ol/extent';


export class WGisOfflineEngine extends WGisEngine implements BaseEngine {
  source: XYZ;

  constructor(options: MapEngineOptions, wgisService: WGisServiceInterface) {
    super(options, wgisService);
    this.createLayer();
    this.url = "cdvfile://localhost/persistent/";
  }

  createLayer() {
    this.type = EngineType.OFFLINEXYZ;
    const opts: XyzOpts = {
      opaque: true,
      crossOrigin: 'anonymous',
      // projection: this.projection,
      tileGrid: new TileGrid({
        extent: <Extent>this.bbox,
        resolutions: this.resolutions,
        tileSize: this.size,
        origin: [this.bbox[0], this.bbox[1]],
      }),
      tileUrlFunction: (tilecoor: TileCoord, pixelratio: number, proj: Projection) => { return this.tileUrl(tilecoor, pixelratio, proj); }
    };

    this.source = new XYZ(opts);
    this.oLayer = new TileLayer({
      source: this.source
    });
    this.registerLayer();
  }

  tileUrl(tilecoor: TileCoord, pixelratio: number, proj: Projection): string {
    function pad(i: number, n: number): string {
      return ("00000000" + i).substr(-n);
    };

    const z = tilecoor[0];
    const x = tilecoor[1];
    const y = Math.abs(1 + tilecoor[2]);
    const path = this.name
      + '/' + pad(z, 2)
      + '/' + pad(Math.round(x / 1000000), 3)
      + '/' + pad(Math.round(x / 1000) % 1000, 3)
      + '/' + pad(Math.round(x) % 1000, 3)
      + '/' + pad(Math.round(y / 1000000), 3)
      + '/' + pad(Math.round(y / 1000) % 1000, 3)
      + '/' + pad(Math.round(y) % 1000, 3)
      + '.' + this.extension;
    return path;
  }


  buildFeature(
    geometry: string,
    attribute: FieldsInterface,
    info: WGisFeatureInfo): WGisFeatureInterface {
    return null;
  }

  feature_factory(fields: FieldsInterface, wkt: string, projection?: string): WGisFeatureInterface {
    return null;
  }
  saveSelection(): void { }

  // OVERIDE ME
  clearSelection(): void { }
  getSelection(): void { }
  addFeatureToSelection(feature: Feature) { }
  removeFeatureFromSelection(feature: Feature) { }
}
